// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable prefer-destructuring */
import Price from "@kiwicom/frontend-common/records/Price"
import type { UsCoverMoreInsuranceAncillaries } from "@kiwicom/frontend-common/services/booking/booking"

import type { UsCoverMoreInsuranceAncillariesInput } from "../../../scenes/BookingAncillary/consts/types"

export default (
  input?: UsCoverMoreInsuranceAncillariesInput,
): UsCoverMoreInsuranceAncillaries | null | undefined => {
  if (!input || !input[0]) return undefined
  const value = input[0]
  return {
    id: value.id,
    extraId: value.extra_id,
    state: value.order_state,
    refundExpiryDate: value.refundable_until,
    passengers: value.items.map((pap) => ({
      id: pap.passenger_id,
      isActive: pap.is_active,
      level: pap.level,
      price: Price.fromServer(pap.price),
      universalId: pap.universal_id,
    })),
  }
}
